import { Inject, inject, Injectable, InjectionToken } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { RestApiConfig } from './model';
import { RecaptchaHttpClient } from '@pc/recaptcha-client-side';

export const REST_API_CONFIG = new InjectionToken<RestApiConfig>('RestApiConfig');

@Injectable({
  providedIn: 'root'
})
export class RestApiService<T> {
  private http = inject(HttpClient);
  private recaptchaService: RecaptchaHttpClient = inject(RecaptchaHttpClient);

  constructor(@Inject(REST_API_CONFIG) private config: RestApiConfig) {}

  public post<T>(apiName: string, payload: unknown, useRecaptcha = false): Observable<T> {
    return useRecaptcha
      ? this.recaptchaService.post<T>(`${this.config.apiUrl}/${apiName}`, payload)
      : this.http.post<T>(`${this.config.apiUrl}/${apiName}`, payload);
  }

  public get(
    apiName: string,
    params?:
      | HttpParams
      | { [param: string]: string | number | boolean | readonly (string | number | boolean)[] }
      | undefined,
    useRecaptcha = false
  ): Observable<T> {
    return useRecaptcha
      ? this.recaptchaService.get<T>(`${this.config}/${apiName}`, params)
      : this.http.get<T>(`${this.config.apiUrl}/${apiName}`, { params: params });
  }
}
